import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import StoreDetailImage$1 from './StoreDetailImage.js';

const StoreDetailImageContainer = (_param)=>{
    var { alt , detailImageUrl , fallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "alt",
        "detailImageUrl",
        "fallbackImage"
    ]);
    const url = detailImageUrl || (fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.url);
    if (!url) {
        return null;
    }
    var ref;
    const altText = !detailImageUrl ? (ref = fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.description) !== null && ref !== void 0 ? ref : alt : alt;
    return /*#__PURE__*/ React__default.createElement(StoreDetailImage$1, swcHelpers.extends({}, rest, {
        storeDetailImageUrl: url,
        isFallbackImage: !detailImageUrl,
        width: !detailImageUrl ? fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.width : undefined,
        height: !detailImageUrl ? fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.height : undefined,
        alt: altText
    }));
};
var StoreDetailImage = StoreDetailImageContainer;

export { StoreDetailImage as default };
//# sourceMappingURL=StoreDetailImageContainer.js.map
